import React from "react";
import styled from "styled-components";

import Input from "./Input";

const Fieldset = styled.fieldset`
  background-color: #232323;
  margin: 0;
  padding: 1em 3em;
`;

const Submit = styled.input`
  align-self: center;
  background-color: #795548;
  border: none;
  padding: 1em 3em;
  border-radius: 2px;
  font-size: 1em;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  color: #fff;
  white-space: nowrap;
  float: right;
  margin-top: 3em;
`;

class Form extends React.PureComponent {
  state = {
    errors: { lei: false, name: false },
    lei: "",
    name: ""
  };

  onSubmit = event => {
    event.preventDefault();
    const company = {
      LEI: this.state.lei.toUpperCase(),
      name: this.state.name
    };

    const exists = this.props.LEIExists(company.LEI);

    let LEIErrors = [];
    if (exists) LEIErrors.push("LEI-koden finns redan registrerad.");
    if (company.LEI === "") LEIErrors.push("LEI-koden måste anges.");
    let NameErrors = [];
    if (company.name === "") NameErrors.push("Namn måste anges.");

    this.setState({
      errors: {
        lei: LEIErrors.length === 0 ? false : LEIErrors,
        name: NameErrors.length === 0 ? false : NameErrors
      }
    });

    if (LEIErrors.length === 0 && NameErrors.length === 0) {
      this.props.onSubmit(company);
      this.setState({
        lei: "",
        name: ""
      });
    }
  };

  onChange = event => {
    event.preventDefault();
    this.setState({
      errors: { lei: false, name: false },
      [event.target.id]: event.target.value
    });
  };

  render() {
    const { disabled } = this.props;
    const { errors, lei, name } = this.state;
    return (
      <form onSubmit={this.onSubmit}>
        <Fieldset disabled={disabled}>
          <Input
            name="lei"
            label="LEI-kod"
            value={lei}
            onChange={this.onChange}
            errors={errors.lei}
          />
          <Input
            name="name"
            label="Namn"
            value={name}
            onChange={this.onChange}
            errors={errors.name}
          />
          <Submit type="submit" value="Lägg till" />
        </Fieldset>
      </form>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/Form.js